import AlterationForm from "../model/AlterationForm";
import Material from "../model/Material";
import SearchCriteria from "../model/SearchCriteria";
import SearchFilterTag from "../ui/search/SearchFilterTag";

class SearchCriteriaTools {
  public static searchCriteriaToQueryString(criteria: SearchCriteria): string {
    const keys = Object.keys(criteria);
    const keyValuePairs: string[] = [];
    keys.map((key) => {
      const value = criteria[key as keyof SearchCriteria];
      if (!key.startsWith("local_") && key !== "last_update") {
        if (value) {
          if (Array.isArray(value)) {
            value.map((val) => {
              keyValuePairs.push(
                encodeURIComponent(key) + "=" + encodeURIComponent(val)
              );
            });
          } else {
            keyValuePairs.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(value.toString())
            );
          }
        }
      }
    });
    return keyValuePairs.join("&");
  }

  public static searchCriteriaToTags(
    criteria: SearchCriteria,
    materials: Material[],
    alterationForms: AlterationForm[],
    onDismiss: (filterType: string, filterValue: string | number) => void
  ) {
    const keys = Object.keys(criteria);
    const keyValuePairs: string[] = [];
    const response: any = [];
    keys.map((key) => {
      if (
        !key.startsWith("local_") &&
        key !== "last_update" &&
        key !== "page" &&
        key !== "per_page" &&
        key !== "order" &&
        key !== "sort"
      ) {
        const value = criteria[key as keyof SearchCriteria];
        if (value) {
          if (Array.isArray(value)) {
            value.map((val) => {
              response.push(
                <SearchFilterTag
                  label={SearchCriteriaTools.getLabelForFilter(
                    key,
                    val,
                    criteria,
                    materials,
                    alterationForms
                  )}
                  filterType={key}
                  filterValue={val}
                  onDismiss={onDismiss}
                />
              );
            });
          } else {
            response.push(
              <SearchFilterTag
                label={SearchCriteriaTools.getLabelForFilter(
                  key,
                  value.toString(),
                  criteria,
                  materials,
                  alterationForms
                )}
                filterType={key}
                filterValue={value.toString()}
                onDismiss={onDismiss}
              />
            );
          }
        }
      }
    });
    return response;
  }

  public static getLabelForFilter(
    filterType: string,
    filterValue: string | number,
    searchCriteria: SearchCriteria,
    materials: Material[],
    alterationForms: AlterationForm[]
  ): string | undefined {
    if (filterType === "alteration_id") {
      for (let i = 0; i < alterationForms.length; i++) {
        if (!alterationForms[i].alterations) {
          continue;
        }
        const alterations = alterationForms[i].alterations!;
        for (let j = 0; j < alterations.length!; j++) {
          if (alterations[j].id === filterValue) {
            return alterations[j].name;
          }
        }
      }
    } else if (filterType === "material_id") {
      for (let i = 0; i < materials.length; i++) {
        if (materials[i].id == filterValue) {
          return materials[i].name;
        }
      }
    } else if (filterType === "types") {
      return filterValue.toString();
    } else if (filterType === "scale") {
      return filterValue.toString();
    } else if (filterType === "category") {
      return filterValue.toString();
    } else if (filterType === "conservation") {
      return filterValue.toString();
    } else if (filterType === "country_id") {
      return searchCriteria.local_country?.name;
    } else if (filterType === "province_id") {
      return searchCriteria.local_province?.name;
    } else if (filterType === "municipality_id") {
      return searchCriteria.local_municipality?.name;
    } else if (filterType === "year_from") {
      return "after year: " + filterValue;
    } else if (filterType === "year_to") {
      return "before year: " + filterValue;
    }
  }
}

export default SearchCriteriaTools;
